module.exports = __webpack_public_path__ + "img/k07.27f6904b.png";